import React from 'react';
import { Navigate } from 'react-router-dom';
// import { useAuth } from '../contexts/AuthContext';

const SuperUserProtectedRoute = ({ children }) => {
  if(sessionStorage.getItem("user")){
      return children;
  }
  
return <Navigate to="/" replace />;

};

export default SuperUserProtectedRoute;
